interface Props {
  className?: string;
}

export default function CheckIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960">
      <path d="M382-208 122-468l90-90 170 170 366-366 90 90-456 456Z" />
    </svg>
  );
}
